var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1002.788,
    height: 309.23,
    viewBox: "0 0 1002.788 309.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267",
    transform: "translate(-361.895 -39.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10266",
    "data-name": "Group 10266",
    transform: "translate(364.931 42.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    d: "M466.847,208.361c-.794.305-1.607.59-2.442.834-37.764,11.476-86.415-38.6-97.911-76.343a71.481,71.481,0,0,1,71.561-92.173c-1.221.285-2.421.61-3.622.977A71.467,71.467,0,0,0,386.862,130.8C396.588,162.783,433.009,203.62,466.847,208.361Z",
    transform: "translate(-363.387 -40.603)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    d: "M506.754,162.45c6.554-23.812,6.906-50.832.924-70.511a74.5,74.5,0,0,0-142.553,43.35c11.047,36.316,53.347,80.181,89.312,80.185h.006c.9,0,1.795-.041,2.684-.1a24.869,24.869,0,0,0,.887,5.644c1.095,3.6,3.518,4.625,6.108,4.625a18.022,18.022,0,0,0,4.873-.853c4.485,2.151,22.457,12.031,15.527,29.406-5.323,13.348-5.878,25.444-1.6,34.981,3.29,7.339,9.382,12.8,17.619,15.789a3.053,3.053,0,0,0,2.084-5.74c-6.743-2.446-11.5-6.668-14.131-12.546-3.583-7.994-3-18.445,1.7-30.222,6.562-16.453-4.214-28.521-13.97-34.666a6.067,6.067,0,0,0,2.02-6.928,24.9,24.9,0,0,0-2.409-5.187C489.68,201.582,500.484,185.221,506.754,162.45Zm-34.35,54.2c.055.189.073.309.094.34-.519.529-2.7,1.192-4.165,1.638-1.508.46-3.77,1.158-4.305,1.03a1.36,1.36,0,0,1-.175-.407,19.492,19.492,0,0,1-.663-4.67c1.231-.254,2.45-.543,3.64-.905s2.373-.789,3.532-1.262A19.411,19.411,0,0,1,472.4,216.645Zm-7.351-8.814a35.358,35.358,0,0,1-5.077,1.133,2.833,2.833,0,0,0-.494.061,37.794,37.794,0,0,1-5.038.344h-.006c-32.529,0-73.087-41.714-83.469-75.857a68.393,68.393,0,1,1,130.868-39.8c5.581,18.353,5.2,44.7-.969,67.116C496.816,175.548,486.779,201.224,465.052,207.831Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10269",
    "data-name": "Group 10269",
    transform: "translate(730.255 -344.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10268",
    "data-name": "Group 10268",
    transform: "translate(169.174 348.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    d: "M241.92,439.8c-11.689,37.111-59.467,85.768-96.966,76.286,32.738-7.234,66.885-45.694,76.531-76.286a71.765,71.765,0,0,0-46.879-90,72.641,72.641,0,0,0-11.342-2.6A71.774,71.774,0,0,1,241.92,439.8Z",
    transform: "translate(-144.954 -346.462)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    d: "M220.191,348.438a74.745,74.745,0,0,0-93.848,48.875c-6.208,19.7-6.125,46.842.217,70.823,6.065,22.931,16.753,39.471,30.576,47.747a24.8,24.8,0,0,0-2.471,5.184c-1.868,5.922,3.176,8.111,6.958,9.359,2.5,4.324,11.783,22.712-3.819,33.177-11.987,8.041-19.311,17.752-21.179,28.08-1.437,7.947.513,15.927,5.64,23.078a3.066,3.066,0,0,0,4.984-3.572c-4.2-5.853-5.742-12.049-4.592-18.412,1.567-8.661,7.984-16.988,18.562-24.081,14.773-9.909,12.692-26.025,8.094-36.653a6.1,6.1,0,0,0,5.605-4.594,24.974,24.974,0,0,0,.946-5.65c1.048.074,2.1.117,3.167.117h0c35.973,0,78.666-43.562,90.03-79.629A74.907,74.907,0,0,0,220.191,348.438ZM169.072,525.607c-.059.188-.112.3-.114.335-.738.135-2.916-.542-4.385-1.008a19.081,19.081,0,0,1-4.148-1.586,1.314,1.314,0,0,1,.088-.437,19.465,19.465,0,0,1,2.093-4.236c1.161.486,2.338.926,3.535,1.3s2.413.681,3.646.948A19.582,19.582,0,0,1,169.072,525.607Zm94.148-85.163c-10.753,34.127-50.7,75.345-84.188,75.341a38.057,38.057,0,0,1-5.274-.374,2.8,2.8,0,0,0-.695-.1,35.178,35.178,0,0,1-5.08-1.181c-21.751-6.854-31.577-32.74-35.5-47.562-5.969-22.575-6.086-49.035-.3-67.412a68.691,68.691,0,1,1,131.03,41.288Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10300",
    "data-name": "Group 10300",
    transform: "translate(184.125 -33.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286",
    transform: "translate(214.374 84.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    "data-name": "Group 10272",
    transform: "translate(105.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M222.772,77.908a11.695,11.695,0,1,1,23.39,0c0,6.461-11.695,76.018-11.695,76.018S222.772,84.369,222.772,77.908Z",
    transform: "translate(-222.772 -66.213)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    "data-name": "Group 10273",
    transform: "translate(159.452 14.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M236.512,75.637A11.7,11.7,0,0,1,256.77,87.332",
    transform: "translate(-236.512 -69.788)",
    fill: "#fedf47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10274",
    "data-name": "Group 10274",
    transform: "translate(146.191 14.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    d: "M246.411,75.637a11.7,11.7,0,0,1,20.258,11.695C263.438,92.925,233.15,122,233.15,122S243.18,81.23,246.411,75.637Z",
    transform: "translate(-233.15 -69.788)",
    fill: "#4caf50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    "data-name": "Group 10275",
    transform: "translate(142.274 52.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    d: "M292.142,81.124a11.7,11.7,0,1,1,11.695,20.258c-5.593,3.23-71.68,27.882-71.68,27.882S286.549,84.355,292.142,81.124Z",
    transform: "translate(-232.157 -79.555)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10276",
    "data-name": "Group 10276",
    transform: "translate(175.43 105.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    d: "M287.342,92.9a11.695,11.695,0,1,1,0,23.39c-6.461,0-46.779-11.695-46.779-11.695S280.882,92.9,287.342,92.9Z",
    transform: "translate(-240.563 -92.899)",
    fill: "#4caf50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10277",
    "data-name": "Group 10277",
    transform: "translate(142.274 131.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4701",
    "data-name": "Path 4701",
    d: "M303.837,127.452a11.7,11.7,0,1,1-11.695,20.258c-5.593-3.23-59.985-48.14-59.985-48.14S298.244,124.222,303.837,127.452Z",
    transform: "translate(-232.157 -99.57)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10278",
    "data-name": "Group 10278",
    transform: "translate(146.191 167.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    d: "M266.669,143.369a11.7,11.7,0,0,1-20.258,11.695c-3.23-5.593-13.261-46.361-13.261-46.361S263.438,137.776,266.669,143.369Z",
    transform: "translate(-233.15 -108.703)",
    fill: "#4caf50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10279",
    "data-name": "Group 10279",
    transform: "translate(105.257 146.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    d: "M246.162,179.3a11.695,11.695,0,1,1-23.39,0c0-6.461,11.695-76.018,11.695-76.018S246.162,172.835,246.162,179.3Z",
    transform: "translate(-222.772 -103.277)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10280",
    "data-name": "Group 10280",
    transform: "translate(52.628 167.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    d: "M231.253,155.064A11.7,11.7,0,0,1,211,143.369c3.23-5.593,33.519-34.666,33.519-34.666S234.484,149.471,231.253,155.064Z",
    transform: "translate(-209.429 -108.703)",
    fill: "#4caf50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281",
    transform: "translate(14.101 131.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    d: "M217.2,147.71a11.7,11.7,0,0,1-11.695-20.258c5.593-3.23,71.683-27.882,71.683-27.882S222.8,144.48,217.2,147.71Z",
    transform: "translate(-199.661 -99.57)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(0 105.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    d: "M207.781,116.289a11.695,11.695,0,0,1,0-23.39c6.461,0,46.783,11.695,46.783,11.695S214.242,116.289,207.781,116.289Z",
    transform: "translate(-196.086 -92.899)",
    fill: "#4caf50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "translate(14.101 52.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4707",
    "data-name": "Path 4707",
    d: "M205.51,101.382A11.7,11.7,0,0,1,217.2,81.124c5.593,3.23,59.989,48.14,59.989,48.14S211.1,104.613,205.51,101.382Z",
    transform: "translate(-199.661 -79.555)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284",
    transform: "translate(52.628 14.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4708",
    "data-name": "Path 4708",
    d: "M211,87.332a11.7,11.7,0,0,1,20.258-11.695",
    transform: "translate(-209.429 -69.788)",
    fill: "#fedf47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285",
    transform: "translate(52.628 14.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4709",
    "data-name": "Path 4709",
    d: "M211,87.332a11.7,11.7,0,0,1,20.258-11.695C234.484,81.23,244.514,122,244.514,122S214.226,92.925,211,87.332Z",
    transform: "translate(-209.429 -69.788)",
    fill: "#4caf50"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10287",
    "data-name": "Group 10287",
    transform: "translate(315.194 185.321)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 16.133,
    cy: 16.133,
    r: 16.133,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10288",
    "data-name": "Group 10288",
    transform: "translate(287.459 60.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10289",
    "data-name": "Group 10289",
    transform: "translate(225.593 95.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10290",
    "data-name": "Group 10290",
    transform: "translate(189.874 157.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10291",
    "data-name": "Group 10291",
    transform: "translate(189.874 229.023)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10292",
    "data-name": "Group 10292",
    transform: "translate(225.593 290.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    transform: "translate(0 0)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10293",
    "data-name": "Group 10293",
    transform: "translate(287.459 326.608)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10294",
    "data-name": "Group 10294",
    transform: "translate(358.897 326.608)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10295",
    "data-name": "Group 10295",
    transform: "translate(420.763 290.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    transform: "translate(0 0)",
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10296",
    "data-name": "Group 10296",
    transform: "translate(456.482 229.023)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10297",
    "data-name": "Group 10297",
    transform: "translate(456.482 157.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10298",
    "data-name": "Group 10298",
    transform: "translate(420.763 95.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10299",
    "data-name": "Group 10299",
    transform: "translate(358.897 60.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 8.149,
    cy: 8.149,
    r: 8.149,
    fill: "#f5821f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/Party.5d283063.svg";
export { ForwardRef as ReactComponent };